import main from "../../assets/img/nature.png"

export default function Nature() {
    return (
        <main className="portfolioDetail">
            <h1>Canadian Museum of Nature - Web Design</h1>
            <img src={main} alt="project information" loading="lazy" />
        </main>
    );
  }